/**
 * Analytics Tracking
 *
 * Tracks user interaction as events, handing them off to
 * Google Tag Manager for implementation into various
 * third-party analytics and marketing apps.
 *
 * [data-event='{ "event": "Newsletter Signup", "location": "in-article-input" }']
 * [data-event='{ "event": "Adunit Clicked", "slug": "campaign-slug", "size": "small" }']
 */
const $ = window.jQuery;

class Analytics {
  constructor() {
    const self = this;
    $("form[data-event]").on("submit", $.proxy(self.trackEvent, self));
    $("button[data-event],input[data-event],a[data-event]").on("click", $.proxy(self.trackEvent, self));
    this.pdfDownload();
  }

  log(label, data) {
    console.log("%c " + label + " ", "background-color:#0000ff; color:white; font-weight:bold");
    console.log("%c" + JSON.stringify(data), "color:#0000ff; font-weight:bold");
  }

  trackEvent(e) {
    let data = $(e.delegateTarget).data("event");

    this.log("Tracked Event", data);

    const isProduction = location.hostname === "www.vitalstrategies.org";
    if (isProduction) dataLayer.push(data);
  }

  pdfDownload() {
    $('a[href*=".pdf"]')
      .attr("target", "_blank")
      .on("click", (event) => {
        const $this = $(event.currentTarget);
        const url = $this.attr("href");
        const file = url.split("/").slice(-1).pop();
        const name = file.replace(/-/g, " ").slice(0, -4);
        const data = {
          event: "PDF Downloaded",
          category: name,
          label: $this.attr("href"),
        };

        this.log("Tracked Event", data);

        const isProduction = location.hostname === "www.vitalstrategies.org";
        if (isProduction) dataLayer.push(data);
      });
  }
}

export default Analytics;
